// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-dialog .el-dialog__body{padding:0;height:563px}.video-dialog video{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
